import React from 'react';
import PropTypes from 'prop-types';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress} from "material-ui";
import {connect} from "react-redux";
import {RegulationForm} from "../../../forms/regulation";
import {
    clearRegulationError,
    closePostRegulationFetch,
    closePutRegulationFetch,
    createRegulation,
    updateRegulation
} from "../../../redux/actions/regulations";
import {snackMessageShow} from "../../../redux/actions/snack_message";

export class RegulationDialog extends React.Component {

    componentDidMount = () => {
        this.props.initialize();
    };

    handleClose = () => {
        this.props.handleClose();
        setTimeout(() => {
            this.props.initialize();
        }, 10);
    };

    handleSubmit = (values) => {
        if (this.props.regulation.id === undefined) {
            this.props.createRegulation({
                ...values,
                user_id: this.props.currentUser.id,
            }, this.handleClose);
        } else {
            this.props.updateRegulation(values, this.handleClose);
        }
    };

    onClickSubmit = () => {
        this.refs.regulationFrom.submit();
    };

    render() {

        const {open, regulation, errors, categories, isPostRegulationFetch, isPutRegulationFetch} = this.props;

        return (
            <Dialog
                open={open}>

                {regulation.id === undefined ? <DialogTitle id="form-dialog-title">法令チェック登録</DialogTitle> : null}
                {regulation.id !== undefined ? <DialogTitle id="form-dialog-title">法令チェック更新</DialogTitle> : null}

                <DialogContent>
                    <RegulationForm
                        errors={errors}
                        onSubmit={this.handleSubmit}
                        ref="regulationFrom"
                        initialValues={regulation}
                        categories={categories}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="default"
                            disabled={isPostRegulationFetch || isPutRegulationFetch}>
                        キャンセル
                    </Button>

                    {regulation.id === undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isPostRegulationFetch}>
                            新規登録
                        </Button>
                        : null}

                    {regulation.id !== undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isPutRegulationFetch}>
                            アップデート
                        </Button>
                        : null}

                </DialogActions>
                {isPostRegulationFetch || isPutRegulationFetch ? <LinearProgress/> : null}
            </Dialog>
        );
    }
}

RegulationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
};

RegulationDialog = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser,
            regulation: state.regulations.regulation,
            errors: state.regulations.errors,
            isPostRegulationFetch: state.regulations.isPostRegulationFetch,
            isPutRegulationFetch: state.regulations.isPutRegulationFetch,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(clearRegulationError());
            },
            createRegulation: (regulation, callback) => {
                dispatch(createRegulation(regulation)).then((response) => {
                    setTimeout(() => {
                        dispatch(closePostRegulationFetch());
                        switch (response.type) {
                            case 'API_CREATE_REGULATION_FAIL':
                                dispatch(snackMessageShow('法令の登録に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('新規法令を登録しました'));
                                callback();
                        }
                    }, 300);

                });
            },

            updateRegulation: (regulation, callback) => {
                dispatch(updateRegulation(regulation)).then((response) => {
                    setTimeout(() => {
                        dispatch(closePutRegulationFetch());
                        switch (response.type) {
                            case 'API_UPDATE_REGULATION_FAIL':
                                dispatch(snackMessageShow('法令の更新に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('法令を更新しました'));
                                callback();
                        }
                    }, 300);

                });
            },
        }
    }
)(RegulationDialog);


// WEBPACK FOOTER //
// ./src/containers/regulation/dialog/index.js